import { FC, useState } from "react";
import { Email as EmailIcon } from '@mui/icons-material';
import posthog from "posthog-js";

const ContactForm: FC = () => {
	const [formData, setFormData] = useState({
		name: '',
		email: '',
		message: ''
	});
	const [isSubmitting, setIsSubmitting] = useState(false);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setIsSubmitting(true);

		try {
			posthog.capture('contact_form_submitted', {
				message: formData.message,
				email: formData.email || undefined,
				name: formData.name || undefined,
				url: window.location.href,
			});

			// Clear form
			setFormData({ name: '', email: '', message: '' });
			alert('Thank you for your feedback!');
		} catch (error) {
			console.error('Failed to submit feedback:', error);
			alert('Sorry, there was an error submitting your feedback. Please try again later. If the problem persists, email contact@vchips.app');
		} finally {
			setIsSubmitting(false);
		}
	};

	const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { name, value } = e.target;
		setFormData(prev => ({
			...prev,
			[name]: value
		}));
	};

	return (
		<div className="max-w-xl mx-auto px-4">
			<div className="flex items-center justify-center mb-8">
				<a
					href="mailto:contact@vchips.app"
					className="flex items-center gap-2 text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors"
				>
					<EmailIcon />
					<code>contact@vchips.app</code>
				</a>
			</div>

			<form onSubmit={handleSubmit} className="space-y-4">
				<div>
					<input
						type="text"
						name="name"
						value={formData.name}
						onChange={handleChange}
						placeholder="Your name, optional"
						className="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
					/>
				</div>

				<div>
					<input
						type="email"
						name="email"
						value={formData.email}
						onChange={handleChange}
						placeholder="Your email, optional"
						className="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
					/>
				</div>

				<div>
					<textarea
						name="message"
						value={formData.message}
						onChange={handleChange}
						placeholder="Message"
						required
						rows={3}
						className="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
					/>
				</div>

				<button
					type="submit"
					disabled={isSubmitting}
					className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
				>
					{isSubmitting ? 'Sending...' : 'Send'}
				</button>
			</form>
		</div>
	);
};

export default ContactForm;
